import {navText} from '../../src/js/functions';

jQuery(document).ready(function ($) {
    $('.block--lux-logos-slider').each(function () {
        let owl = $(this).find(' .owl-carousel');
        if (!owl) return;
        owl.owlCarousel({
            loop: true,
            dots: false,
            autoWidth: true,
            center: true,
            nav: true,
            margin: 18,
            responsive: {
                992: {
                    margin: 52,
                }
            },
            navText: navText('#637381'),
        });
    });
});
